//@flow
import {makeStyles, Typography} from '@material-ui/core';
import {ErrorOutline} from '@material-ui/icons';
import React from 'react';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import CustomModal from '../../../../../elements/CustomModal/CustomModal';

import {colors} from '../../../../../assets/styles/colors';

type Props = {
  open?: boolean,
  onClose?: () => void,
  message: string,
  onConfirmWithHistoryDelete: () => void,
  onConfirmWithoutHistoryDelete?: () => void,
  title?: string,
  className?: string,
  withHistoryButtonLabel?: string,
  withoutHistoryButtonLabel?: string,
  icon?: React$Node,
  service?: string,
};

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 600,
    margin: '0 auto',
  },
  warningIcon: {
    fontSize: '1.25rem',
    width: 100,
    height: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    margin: '1rem auto',
    background: colors.warning,
    color: 'white',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  message: {
    maxWidth: 300,
    textAlign: 'center',
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'center',
    width: '100%',
    margin: '1rem 0',
  },
  button: {
    padding: '10px 2px',
  },
}));

export default function ConfirmModalDelete(props: Props) {
  const {
    onClose,
    open,
    onConfirmWithHistoryDelete,
    onConfirmWithoutHistoryDelete,
    message,
    className = '',
    title = '¿Estás seguro de esta acción?',
    icon,
    withHistoryButtonLabel = 'Eliminar canal',
    withoutHistoryButtonLabel = 'Desconectar sin borrar historial',
    service,
  } = props;

  const isWhatsAppWeb = service === 'WHATSAPP_WEB';

  const classes = useStyles();

  return (
    <CustomModal
      open={open}
      handleCloseModal={onClose}
      className={`${classes.root} ${className}`}
    >
      <div className={classes.header}>
        <span className={classes.warningIcon}>
          {icon ? icon : <ErrorOutline fontSize="large" />}
        </span>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
      </div>
      <Typography className={classes.message}> {message}</Typography>
      <div className={classes.options}>
        {isWhatsAppWeb && onConfirmWithoutHistoryDelete && (
          <CustomButton
            onClick={onConfirmWithoutHistoryDelete}
            className={classes.button}
            variant="contained"
            fullWidth
          >
            {withoutHistoryButtonLabel}
          </CustomButton>
        )}

        <CustomButton
          className={classes.button}
          variant="contained"
          color="default"
          onClick={onConfirmWithHistoryDelete}
          fullWidth
        >
          {withHistoryButtonLabel}
        </CustomButton>
      </div>
    </CustomModal>
  );
}
